<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga Elektronik 0-15" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_ELEK_1" id="persenBungaElek" name="persenElektronik1" step="0.01" @blur="roundPersen(1)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaElek" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga elektronik untuk durasi 0 - 15 hari</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga Elektronik 16-30" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_ELEK_2" id="persenBungaElek2" name="persenElektronik2" step="0.01" @blur="roundPersen(2)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaElek2" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga elektronik untuk durasi 16 - 30 hari / jatuh tempo</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga Kendaraan 0-15" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_KEND_1" id="persenBungaKend" name="persenKendaraan1" step="0.01" @blur="roundPersen(3)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaKend" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga kendaraan untuk durasi 0 - 15 hari</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga Kendaraan 16-30" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_KEND_2" id="persenBungaKend1" name="persenKendaraan2" step="0.01" @blur="roundPersen(4)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaKend1" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga kendaraan untuk durasi 16 - 30 hari / jatuh tempo</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga BPKB 0-15" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_BPKB_1" id="persenBungaBpkb1" name="persenBpkb1" step="0.01" @blur="roundPersen(5)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaBpkb1" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga BPKB untuk durasi 0 - 15 hari</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bunga BPKB 16-30" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BUNGA_BPKB_2" id="persenBungaBpkb2" name="persenBpkb2" step="0.01" @blur="roundPersen(6)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBungaBpkb2" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase bunga BPKB untuk durasi 16 - 30 hari / jatuh tempo</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bonus Bunga Didepan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.BONUS_BUNGA_DIDEPAN" id="persenHargaBonusBungaDidepan" name="persenHargaBonusBungaDidepan" step="0.01" @blur="roundPersen(7)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenHargaBonusBungaDidepan" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan Harga Barang.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Harga Barang adalah 1.000.000 dan persentase 50%,
                                        maka pinjaman maksimal akan ditambahkan sebesar 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase penambahan pinjaman maksimal untuk cabang yang memberlakukan skema Bunga Didepan.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Harga Taksiran" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.HARGA_TAKSIRAN" id="persenHargaTaksiran" name="persenHargaTaksiran" step="0.01" @blur="roundPersen(8)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenHargaTaksiran" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan pinjaman maksimal.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Maks. Pinjaman adalah 1.000.000 dan persentase 120%,
                                        maka Harga Taksiran adalah 1.200.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase harga taksiran yang ditampilkan pada simulasi gadai</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Pinjaman Minimal" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.PINJAMAN_MINIMAL" id="persenPinjamanMinimal" name="persenPinjamanMininal" step="0.01" @blur="roundPersen(9)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenPinjamanMinimal" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan pinjaman maksimal.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Maks. Pinjaman adalah 1.000.000 dan persentase 50%,
                                        maka Pinjaman Minimal adalah 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase pinjaman minimal yang harus diajukan oleh anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Minimum Pinjaman Didapatkan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL" id="persentaseMinimumPinjamanDidapatkan" name="persentaseMinimumPinjamanDidapatkan" step="0.01" @blur="roundPersen(10)" type="number" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase terhadap harga barang, yang dijadikan minimum pinjaman maksimal yang didapatkan.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Minimum Pokok Awal" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="bungaGadaiInput.MINIMUM_POKOK_AWAL" name="minPokokAwal" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Nominal minimal pinjaman awal / pokok yang harus diambil anggota ketika menggadaikan.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval KU" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="bungaGadaiInput.NOTIF_KU_MIN" name="minNotifKu" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke KU cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval KC" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="bungaGadaiInput.NOTIF_KC_MIN" name="minNotifKc" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke KC cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval AM" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="bungaGadaiInput.NOTIF_KCS_MIN" name="minNotifKcs" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke AM cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Nilai X" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="bungaGadaiInput.PERSENTASE_NILAI_X" id="persenNilaiX" name="persenNilaiX" step="0.01" @blur="roundPersen(11)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenNilaiX" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Menggunakan rumus:</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        (Sisa Pinjaman - Total Jasa Terbayar) x Input%
                                    </span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila hasil lebih kecil dari nol, maka Nilai X akan dibulatkan menjadi nol.
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase yang digunakan ketika menghitung Nilai X sebuah lelangan</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Device Info" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="bungaGadaiInput.HARGA_HANDPHONE_CPU_Z" name="minNotifKcs" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum harga barang Handphone dan Tablet non-Apple untuk memunculkan warning Device Info</span>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-bungaGadai" title="Confirm Edit Parameter Bunga Gadai" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter bunga gadai ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'bunga-gadai',
    props: {
        bungaGadaiInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            newData: {}
        }
    },
    watch: {
        "bungaGadaiInput.MINIMUM_POKOK_AWAL": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.bungaGadaiInput.MINIMUM_POKOK_AWAL = result);
        },
        "bungaGadaiInput.NOTIF_KU_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KU_MIN = result);
        },
        "bungaGadaiInput.NOTIF_KC_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KC_MIN = result);
        },
        "bungaGadaiInput.NOTIF_KCS_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KCS_MIN = result);
        },
        "bungaGadaiInput.HARGA_HANDPHONE_CPU_Z": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.bungaGadaiInput.HARGA_HANDPHONE_CPU_Z = result);
        },
    },
    methods: {
        //----------------- Fungsi Submit Data -----------------

        onSubmit() {

            this.newData = JSON.parse(JSON.stringify(this.bungaGadaiInput))
            
            const minimumPokokAwal = this.$helper.removeThousandSeparator(this.newData.MINIMUM_POKOK_AWAL);
            this.newData.MINIMUM_POKOK_AWAL = minimumPokokAwal;
            const numberNotifKu = this.$helper.removeThousandSeparator(this.newData.NOTIF_KU_MIN);
            this.newData.NOTIF_KU_MIN = numberNotifKu;
            const numberNotifKc = this.$helper.removeThousandSeparator(this.newData.NOTIF_KC_MIN);
            this.newData.NOTIF_KC_MIN = numberNotifKc;
            const numberNotifKcs = this.$helper.removeThousandSeparator(this.newData.NOTIF_KCS_MIN);
            this.newData.NOTIF_KCS_MIN = numberNotifKcs;
            const numberHandphoneCpuZ = this.$helper.removeThousandSeparator(this.newData.HARGA_HANDPHONE_CPU_Z);
            this.newData.HARGA_HANDPHONE_CPU_Z = numberHandphoneCpuZ;

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                
                this.$helper.toastSucc(this, "Parameter Bunga Gadai telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-bungaGadai")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-edit-bungaGadai")
        },

        roundPersen(id){
            if(id == 1){
                var persenElektronik1 = Number(this.bungaGadaiInput.BUNGA_ELEK_1).toFixed(2);
                this.bungaGadaiInput.BUNGA_ELEK_1 = persenElektronik1;
            }else if(id == 2){
                var persenElektronik2 = Number(this.bungaGadaiInput.BUNGA_ELEK_2).toFixed(2);
                this.bungaGadaiInput.BUNGA_ELEK_2 = persenElektronik2;
            }else if(id == 3){
                var persenKendaraan1 = Number(this.bungaGadaiInput.BUNGA_KEND_1).toFixed(2);
                this.bungaGadaiInput.BUNGA_KEND_1 = persenKendaraan1;
            }else if(id == 4){
                var persenKendaraan2 = Number(this.bungaGadaiInput.BUNGA_KEND_2).toFixed(2);
                this.bungaGadaiInput.BUNGA_KEND_2 = persenKendaraan2;
            }else if(id == 5){
                var persenBpkb1 = Number(this.bungaGadaiInput.BUNGA_BPKB_1).toFixed(2);
                this.bungaGadaiInput.BUNGA_BPKB_1 = persenBpkb1;
            }else if(id == 6){
                var persenBpkb2 = Number(this.bungaGadaiInput.BUNGA_BPKB_2).toFixed(2);
                this.bungaGadaiInput.BUNGA_BPKB_2 = persenBpkb2;
            }else if(id == 7){
                var persenBonusBungaDidepan = Number(this.bungaGadaiInput.BONUS_BUNGA_DIDEPAN).toFixed(2);
                this.bungaGadaiInput.BONUS_BUNGA_DIDEPAN = persenBonusBungaDidepan;
            }else if(id == 8){
                var persenHargaTaksiran = Number(this.bungaGadaiInput.HARGA_TAKSIRAN).toFixed(2);
                this.bungaGadaiInput.HARGA_TAKSIRAN = persenHargaTaksiran;
            }else if(id == 9){
                var persenPinjamanMininal = Number(this.bungaGadaiInput.PINJAMAN_MINIMAL).toFixed(2);
                this.bungaGadaiInput.PINJAMAN_MINIMAL = persenPinjamanMininal;
            }else if(id == 10){
                var persentaseMinimumPinjamanDidapatkan = Number(this.bungaGadaiInput.PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL).toFixed(2);
                this.bungaGadaiInput.PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL = persentaseMinimumPinjamanDidapatkan;
            }else{
                var persenNilaiX = Number(this.bungaGadaiInput.PERSENTASE_NILAI_X).toFixed(2);
                this.bungaGadaiInput.PERSENTASE_NILAI_X = persenNilaiX;
            }
        }
    },
    created(){
    }
}
</script>